import React, { Component } from 'react'; // eslint-disable-line

const DisplayOptionsBox = (props) => {
    return (
        <div className="module-display-setting__options">
            <h4>{props.title}</h4>
            {props.children}
        </div>
    );
};

export default DisplayOptionsBox;
